import type { BrowserOptions } from '@sentry/nextjs';

export enum TagTheme {
	AspenDental = 'aspendental',
	TeamTag = 'teamTag',
	WellNow = 'wellnow',
	Chapter = 'chapter',
	ClearChoice = 'clearchoice',
	Lovet = 'lovet',
}
// Add a few options for Cache Control
// CACHE_CONTROL_NO_CACHE: Used for API get requests that should not be cached
// CACHE_CONTROL_SHORT_TTL: Used for HTML Templates that should be cached for a short period of time
//                          Caching Notes:
//                           - 10 seconds for the browser, 60 seconds for the CDN, and 60 seconds for the CDN to revalidate
//                           - 0 seconds for the CDN to serve stale content if the origin is down
// Refer to: https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/Expiration.html
export const CACHE_CONTROL_NO_CACHE = 'no-cache, max-age=0, must-revalidate';
export const CACHE_CONTROL_SHORT_TTL = 'public, max-age=10, s-maxage=60, stale-while-revalidate=60, stale-if-error=0';
export const CACHE_CONTROL_FOR_ONE_DAY =
	'public, max-age=86400, s-maxage=86400, stale-while-revalidate=60, stale-if-error=0';

export const NOT_FOUND = {
	notFound: true,
} as const;

const endpointOverride = process.env.CONTENTFUL_GRAPHQL_ENDPOINT;
const contentfulEnvironmentSuffix = process.env.CONTENTFUL_ENVIRONMENT_ID
	? `/environments/${process.env.CONTENTFUL_ENVIRONMENT_ID}`
	: '';
const productionEndpoint = 'https://graphql.contentful.com/content/v1/spaces';
export const contentfulGraphQLURL = `${endpointOverride || productionEndpoint}/${
	process.env.CONTENTFUL_SPACE_ID
}${contentfulEnvironmentSuffix}`;
export const SENTRY_DSN =
	'https://a002fd922a6c795aedf5e89d4391c3e1@o4508615315554304.ingest.us.sentry.io/4509005905657856';

// Sentry v11 replaced `sendDefaultPii` with `dataCollection`, and leaving it unset now collects cookies, user info,
// request/response bodies, etc. by default. Pin the v10 baseline so the upgrade doesn't widen what we send to Sentry.
// https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#if-you-want-to-keep-the-v10-default-behavior
export const SENTRY_DATA_COLLECTION: BrowserOptions['dataCollection'] = {
	userInfo: false,
	cookies: false,
	httpHeaders: {
		request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
		response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
	},
	httpBodies: [],
	urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
	genAI: { inputs: false, outputs: false },
	databaseQueryData: false,
	queues: false,
	graphQL: { document: false, variables: false },
};
